import React from "react";

export const BRAND_NAVY = "#0A1628";
export const BRAND_EMERALD = "#00C896";

// "fl" monogram: navy "f" (find) whose hook joins the emerald "l" (loop), on a white tile.
export const Monogram = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-testid="findloop-monogram">
    <rect x="0.6" y="0.6" width="46.8" height="46.8" rx="11" fill="#FFFFFF" stroke="#E2E6EE" strokeWidth="1.2" />
    <g strokeWidth="5.2" strokeLinecap="round" fill="none">
      <path d="M17 39V17a7.5 7.5 0 0 1 11.25 -6.5" stroke={BRAND_NAVY} />
      <line x1="11.5" y1="23" x2="24.5" y2="23" stroke={BRAND_NAVY} />
      <path d="M32.5 9v24a5.5 5.5 0 0 0 5.5 5.5" stroke={BRAND_EMERALD} />
    </g>
  </svg>
);

// "Findloop" wordmark: Find (regular) + loop (bold), the first "o" drawn as a closed emerald loop.
export const Wordmark = ({ className = "", style }) => (
  <span className={`inline-flex items-baseline font-brand tracking-tight leading-none ${className}`} style={style} data-testid="findloop-wordmark" role="img" aria-label="Findloop">
    <span className="font-normal">Find</span>
    <span className="font-bold">l</span>
    <span className="inline-block rounded-full self-center"
      style={{ width: "0.5em", height: "0.5em", border: `0.13em solid ${BRAND_EMERALD}`, margin: "0.12em 0.04em 0 0.05em" }} aria-hidden="true" />
    <span className="font-bold">op</span>
  </span>
);

export default function Logo({ size = 36, withText = false, textClass = "", inverted }) {
  const inv = inverted ?? /\btext-white\b/.test(textClass);
  return (
    <span className="inline-flex items-center gap-2.5" data-testid="findo-logo">
      <Monogram size={size} />
      {withText && <Wordmark className={textClass} />}
    </span>
  );
}
